const STORAGE_KEY = 'mall_order_tracking_identities_v1'
const MAX_IDENTITIES = 200
const MAX_ALIASES = 100
let memoryIdentities = []
let useMemoryIdentities = false

// 编号必须带字段类型：支付单号和商城订单号即使文本相同，也不是同一身份。
// 只有接口/本地订单同时提供两种编号时，才建立关联，不根据长度或前缀猜测。
export function getOrderTrackingAliases({ orderCode, payOrderCode } = {}) {
  return [['order', orderCode], ['payment', payOrderCode]]
    .filter(([, value]) => value !== undefined && value !== null && String(value).trim())
    .map(([type, value]) => `${type}:${String(value).trim()}`)
}

function readIdentities() {
  if (useMemoryIdentities)
    return memoryIdentities
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    if (stored !== null) {
      const parsed = JSON.parse(stored)
      memoryIdentities = Array.isArray(parsed)
        ? parsed.filter(item => typeof item?.scope === 'string'
          && typeof item.recordKey === 'string' && Array.isArray(item.aliases)
          && item.aliases.every(alias => typeof alias === 'string')).slice(-MAX_IDENTITIES)
        : []
    }
  }
  catch {
    // 隐私模式、存储满或旧数据损坏时退回内存，不能影响订单成功主流程。
    useMemoryIdentities = true
  }
  return memoryIdentities
}

// 此处只关联身份，不表示上报成功。成功标记和重试仍由调用方的 ACK/队列管理。
// scope 应包含事件、站点和店铺；零金额诊断不能拦截后续正常 Purchase。
export function resolveOrderTrackingKey({ scope, aliases, candidateKeys, knownKeys = [], knownIdentities = [] }) {
  const fallbackKey = candidateKeys[0] || ''
  if (typeof window === 'undefined' || !aliases.length || !fallbackKey)
    return fallbackKey

  try {
    const identities = readIdentities()
    const matched = [...identities, ...knownIdentities].filter(item => item.scope === scope
      && item.aliases.some(alias => aliases.includes(alias)))
    // 优先复用已 ACK 或仍在队列中的键，兼容升级前按单一编号保存的记录。
    const matchingKeys = new Set([...candidateKeys, ...matched.map(item => item.recordKey)])
    const recordKey = knownKeys.find(key => matchingKeys.has(key))
      || matched[0]?.recordKey || fallbackKey
    const mergedAliases = [...new Set([...matched.flatMap(item => item.aliases), ...aliases])].slice(-MAX_ALIASES)
    memoryIdentities = [
      ...identities.filter(item => !matched.includes(item)),
      { scope, recordKey, aliases: mergedAliases },
    ].slice(-MAX_IDENTITIES)
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(memoryIdentities))
      useMemoryIdentities = false
    }
    catch {
      // 仍保留当前页面的内存关联；禁止将统计存储失败抛到支付页面。
      // 写失败后不要再用磁盘旧值覆盖刚补齐的支付单号。
      useMemoryIdentities = true
    }
    return recordKey
  }
  catch {
    return fallbackKey
  }
}
